// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "saveContactInfo__modal-2dFsx";
var _3 = "root-3qosI";
var _4 = "saveContactInfo__title-1BLzE";
export { _1 as "__esModule", _2 as "saveContactInfo__modal", _3 as "root", _4 as "saveContactInfo__title" }
export default { "__esModule": _1, "saveContactInfo__modal": _2, "root": _3, "saveContactInfo__title": _4 }
